<template>
  <div class="section">
    <div class="columns is-centered">
      <div
        class="column is-full-mobile is-8-tablet is-5-desktop is-3-widescreen is-3-fullhd"
        style="text-align: center"
      >
        <h1 class="title is-4">Passwort ändern</h1>
        <div v-if="data">
          <div class="block">
            <b-message type="is-success">
              Ihr neues Passwort wurde gespeichert.
            </b-message>
          </div>

          <div class="block">
            <b-button tag="router-link" :to="{ name: 'UserProfile' }" expanded>
              zurück zum Profil
            </b-button>
          </div>
        </div>
        <div v-else>
          <div v-if="error" class="block">
            <b-message type="is-danger">
              {{ error }}
            </b-message>
          </div>

          <div class="block">
            <ValidationObserver
              ref="observer"
              v-slot="{ handleSubmit, invalid }"
            >
              <div
                v-on:keyup.enter="handleSubmit(submit)"
                style="text-align: left"
              >
                <div class="block">
                  <BInputWithValidation
                    rules="required|min:6"
                    type="password"
                    label="Altes Passwort"
                    v-model="password"
                    password-reveal
                  />
                </div>

                <div class="block">
                  <BInputWithValidation
                    rules="required|min:6"
                    type="password"
                    label="Neues Passwort"
                    v-model="new_password"
                    password-reveal
                  />
                </div>

                <div class="block">
                  <BInputWithValidation
                    :rules="`required|is:${new_password}`"
                    type="password"
                    label="Neues Passwort wiederholen"
                    password-reveal
                  />
                </div>

                <div class="block">
                  <b-button
                    type="is-outlined is-gold"
                    expanded
                    :disabled="invalid"
                    :loading="loading"
                    @click="handleSubmit(submit)"
                  >
                    Speichern
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
          </div>

          <div class="block">
            <b-button tag="router-link" :to="{ name: 'UserProfile' }" expanded>
              Zurück zum Profil
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'Activate',
  components: {
    BInputWithValidation,
  },
  data() {
    return {
      password: null,
      new_password: null,
    };
  },
  methods: {
    submit() {
      this.$store.dispatch('auth/passwordChange/PUSH', { new_password: this.new_password, password: this.password });
    },
  },
  computed: {
    ...mapGetters({ data: 'auth/passwordChange/data', error: 'auth/passwordChange/error', loading: 'auth/passwordChange/loading' }),
  },
  mounted() {
    this.$store.commit('auth/passwordChange/SET_DATA_CLEAR');
    this.$store.commit('auth/passwordChange/CLEAR_ERROR');
  },
};
</script>
